import React from 'react';

import {Button, CrossIcon, Select} from '@kit';

import {cls} from '../../../../components/utils';
import {useCharacter} from '../character-context';
import {choicesWithErrors} from '../model/choice-limits';
import {MAX_CHARACTER_LEVEL} from '../model/character-state';
import type {ClassFeatures, FeatureInstance} from '../model/feature-tree';
import {classIconUrl} from './class-list';
import {FeatureDetails} from './feature-details';

import css from './master.module.css';

type Props = {
	classFeatures: ClassFeatures;
};

export const ClassSection: React.FC<Props> = ({classFeatures}) => {
	const {character, update} = useCharacter();
	const {classData, classLevel, isStartingClass, subClass, features} = classFeatures;
	const hasErrors = choicesWithErrors(features, character).length > 0;
	const maxClassLevel = MAX_CHARACTER_LEVEL - character.level + classLevel.level;

	const setLevel = (level: number) =>
		update((current) => ({
			classes: current.classes.map((entry) => (entry.classId === classData.id ? {...entry, level} : entry)),
		}));

	const removeClass = () =>
		update((current) => ({classes: current.classes.filter((entry) => entry.classId !== classData.id)}));

	const featureCaption = (instance: FeatureInstance) => {
		const levelText = `${instance.level}-й уровень`;
		return instance.feature.subClassId && subClass ? `${levelText} (${subClass.title})` : levelText;
	};

	return (
		<section className={cls(css.classSection, hasErrors && css.classSectionError)}>
			<header className={css.classHeader}>
				<div className={css.classHeaderTitle}>
					<img src={classIconUrl(classData.id)} alt="" width={50} height={50} className={css.classIcon} />
					<div>
						<h3 className={css.classTitle}>{classData.title}</h3>
						{isStartingClass && <div className={css.classCaption}>Стартовый класс</div>}
						{hasErrors && <div className={css.classError}>Повышение характеристики больше предела</div>}
					</div>
				</div>
				<div className={css.classHeaderActions}>
					<Select
						className={css.levelSelect}
						label="Уровень"
						disableClear
						items={Array.from({length: maxClassLevel}, (_, index) => ({
							value: index + 1,
							label: `${index + 1}`,
						}))}
						value={classLevel.level}
						onChange={([level]) => setLevel(Number(level) || 1)}
					/>
					<Button icon={<CrossIcon />} onClick={removeClass}>
						Убрать
					</Button>
				</div>
			</header>
			{features.map((instance) => (
				<FeatureDetails key={instance.key} instance={instance} caption={featureCaption(instance)} />
			))}
		</section>
	);
};
